// SPDX-License-Identifier: AGPL-3.0-or-later

import {
	buildGoogleFaviconUrl,
	TAB_DISGUISE_MODE_CUSTOM,
	TAB_DISGUISE_MODE_NONE,
	TAB_DISGUISE_PRESETS,
} from '@app/features/tab_disguise/state/TabDisguise';
import * as UserSettingsCommands from '@app/features/user/commands/UserSettingsCommands';

export async function setTabDisguiseMode(mode: string): Promise<void> {
	if (mode === TAB_DISGUISE_MODE_NONE) {
		await UserSettingsCommands.update({tabDisguiseMode: TAB_DISGUISE_MODE_NONE});
		return;
	}
	const preset = TAB_DISGUISE_PRESETS[mode];
	if (preset) {
		await UserSettingsCommands.update({
			tabDisguiseMode: preset.mode,
			tabDisguiseTitle: preset.title,
			tabDisguiseFavicon: preset.favicon,
		});
		return;
	}
	await UserSettingsCommands.update({tabDisguiseMode: TAB_DISGUISE_MODE_CUSTOM});
}

export async function setCustomTabDisguise(params: {title: string; domain: string}): Promise<void> {
	const title = params.title.trim();
	const domain = params.domain.trim();
	const favicon = domain ? buildGoogleFaviconUrl(domain) : '';
	await UserSettingsCommands.update({
		tabDisguiseMode: TAB_DISGUISE_MODE_CUSTOM,
		tabDisguiseTitle: title || null,
		tabDisguiseFavicon: favicon || null,
	});
}
